// components/CourseProgressIndicator.jsx
import React from 'react';
import {
    Box,
    CircularProgress,
    Typography,
    Alert,
    Button,
    LinearProgress,
} from '@mui/material';
import MainCard from '../cards/MainCard'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

const getStepMessages = (mode) => ({
    creating_course: mode === 'edit' ? 'Updating course...' : 'Creating course...',
    uploading_content: 'Uploading course content...',
    uploading_media: 'Uploading images...',
    processing: 'Processing course files (this may take up to 30 seconds)...',
    complete: mode === 'edit' ? 'Course updated successfully!' : 'Course created successfully!',
    error: 'An error occurred',
});

export default function CourseProgressIndicator({ state, error, onRetry, onComplete, mode = 'create' }) {
    const STEP_MESSAGES = getStepMessages(mode);
    const isProcessing = !['complete', 'error', 'editing'].includes(state);
    const isComplete = state === 'complete';
    const isError = state === 'error';

    return (
        <MainCard
            border={false}
            boxShadow={false}
            sx={{
                p: 4,
                textAlign: 'center',
                maxWidth: 600,
                mx: 'auto',
                mt: 4,
                minHeight: '400px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'transparent'
            }}
        >
            <Box sx={{ width: '100%' }}>
                {isProcessing && (
                    <>
                        <CircularProgress size={60} sx={{ mb: 2 }} />
                        <Typography variant="h5" gutterBottom>
                            {STEP_MESSAGES[state]}
                        </Typography>
                        <LinearProgress sx={{ mt: 2 }} />
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                            Please don't close this page or navigate away
                        </Typography>
                    </>
                )}
                {isComplete && (
                    <>
                        <CheckCircleIcon
                            color="primary"
                            sx={{ fontSize: 60, mb: 2 }}
                        />
                        <Typography variant="h5" gutterBottom>
                            {STEP_MESSAGES[state]}
                        </Typography>
                        {onComplete && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={onComplete}
                                sx={{ mt: 2 }}
                            >
                                Continue
                            </Button>
                        )}
                    </>
                )}
                {isError && (
                    <>
                        <ErrorIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
                        <Typography variant="h5" gutterBottom color="error">
                            {STEP_MESSAGES[state]}
                        </Typography>
                        <Alert severity="error" sx={{ mt: 2, textAlign: 'left' }}>
                            {error || 'An unexpected error occurred'}
                        </Alert>
                        {onRetry && (
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={onRetry}
                                sx={{ mt: 2 }}
                            >
                                Retry
                            </Button>
                        )}
                    </>
                )}
            </Box>
        </MainCard>
    );
}